export const MAX_HISTORY_ENTRIES = 20;
export const STAMP_ANIMATION_MS = 220;
